import { Checkbox, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { CommonSelect } from "../common";


//inline styles
const InlineStyles = {
    TableHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        height: "50px",
        color: "#ffffff",
        backgroundColor: "#1672DE",
    },
    TableCells: {
        color: 'black',
        fontSize: '12px',
        height: '44px',
        padding: '0px'
    },
    TableBodyRows: {
        border: '1px solid #ddd', marginTop: "10px", paddingTop: "15px", verticalAlign: "top"
    },
    TableBodyRowCells: {
        height: '20px', padding: '0px'
    },
    PaymentReceiveDate: {
        width: "100px", height: "33px", padding: "0px"
    },
    BrokerBranchTableCell: {
        height: "20px", padding: "3px", width: "150px"
    },
    ReceivableAmountTableCell: {
        height: "20px", padding: "3px"
    },
    PaymentCurrencyCodeTableCell: {
        height: "20px", padding: "3px"
    },
    BankExchangeRateTableCell: {
        height: "20px", padding: "3px"
    },
    BankExchangeChargesTableCell: {
        height: "20px", padding: "3px"
    },
    entity_divisionsTableCell: {
        height: "20px", padding: "3px"
    },
    entity_divisions: {
        position: "relative", width: "123px", height: "32"
    },
    MoreVertIconStyle: {
        color: 'FF5A01',
        background: 'transparent',
        cursor: 'pointer',
        transform: 'rotate(90deg)'
    },
    BankChargesTableCell: {
        height: "20px", padding: "3px"
    }

}
export const AddCorrection = ({
    allocationStatus,
    selectAll,
    handleSelectAll,
    handleInputChange,
    handleCheckboxChange,
    rows,
    viewMode,
    validationStatus,
    handleentity_divisionsOpenDialog,
    selectedRows,
    handleBrokerBranchDropdown,
}) => {

    return (
        <Table>
            <TableHead
                style={InlineStyles.TableHeader}>
                <TableRow>
                    <TableCell style={InlineStyles.TableCells}>
                        <Checkbox
                            checked={selectAll}
                            onChange={handleSelectAll}
                            style={{ color: "black" }}
                        />
                    </TableCell>
                    <TableCell className='TableCell'>Correction Reason</TableCell>
                    <TableCell className='TableCell'>Correction Description</TableCell>
                    <TableCell className='TableCell'>Allocation Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row, index) => (
                    <TableRow key={index} style={InlineStyles.TableBodyRows}>
                        <TableCell sx={InlineStyles.TableBodyRowCells}>
                             <Checkbox sx={{ backgroundColor: "#ffffff", color: "#1672DE", "&.Mui-checked": { color: "#1672DE" } }}
                                checked={selectedRows[index] || false}
                                onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                            />
                        </TableCell>

                        <TableCell sx={InlineStyles.entity_divisionsTableCell}>
                            <TextField
                                value={row.correction_type}
                                onChange={(e) => handleInputChange(index, 'correction_type', e.target.value)}
                                sx={InlineStyles.entity_divisions}
                                size="small"
                                placeholder='Enter Details Here'
                                disabled={viewMode}

                            /><br />
                            {validationStatus[index]?.correction_type && (
                                <span style={{ color: 'red' }}>{validationStatus[index]?.correction_type}</span>
                            )}
                        </TableCell>
                        <TableCell sx={InlineStyles.entity_divisionsTableCell}>
                            <TextField
                                value={row.correction_description}
                                onChange={(e) => handleInputChange(index, 'correction_description', e.target.value)}
                                sx={InlineStyles.entity_divisions}
                                size="small"
                                placeholder='Enter Details Here'
                                disabled={viewMode}

                            /><br />
                            {validationStatus[index]?.correction_description && (
                                <span style={{ color: 'red' }}>{validationStatus[index]?.correction_description}</span>
                            )}
                        </TableCell>
                        <TableCell sx={InlineStyles.BrokerBranchTableCell}>
                            <CommonSelect
                                disabled={viewMode}
                                handleChange={(event, value, reason) =>
                                    handleInputChange(
                                        index,
                                        'allocation_status',
                                        value,
                                        reason,
                                        event
                                    )
                                }
                                name="Allocation Status"
                                // Map through your list of dropdown values
                                options={allocationStatus?.map((option) => option.allocation_status)}
                                placeholder="Select Currency"
                                value={row.allocation_status}
                            />
                            {validationStatus[index]?.allocation_status && (
                                <span style={{ color: 'red' }}>{validationStatus[index]?.allocation_status}</span>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}